module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/may/mainvisual-title_40ccd9ba7d53bbb4f2372c7130540c93.png";